<template>
  <v-card class="content-card mb-4" elevation="1">
    <v-card-title class="card-title d-flex align-center">
      <span class="flex-grow-1">{{ title }}</span>
      <v-btn
        v-if="selectedNavKey && !activeEditor"
        color="primary"
        @click="$emit('save')"
        class="save-btn"
      >
        儲存模板
      </v-btn>
    </v-card-title>
    <v-card-text>
      <template v-for="(template, index) in templates">
        <div :key="`label-${index}`" class="font-weight-bold">
          {{ getTemplateLabel(template, index) }}
        </div>
        <v-textarea
          :key="`editor-${index}`"
          :value="template.content"
          @input="handleTemplateUpdate(index, $event)"
          solo
          :label="`請在此輸入${getTemplateLabel(template, index)}`"
          class="editor-textarea mb-3"
          rows="5"
        ></v-textarea>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TemplateEditor',
  props: {
    title: {
      type: String,
      required: true,
    },
    templates: {
      type: Array,
      default: () => [],
    },
    selectedNavKey: {
      type: String,
      default: null,
    },
    activeEditor: {
      type: String,
      default: null,
    },
  },
  methods: {
    getTemplateLabel(template, index) {
      if (template.templateType === 'plural') {
        return '複數模板';
      } else if (template.templateType === 'single') {
        const singleTemplates = this.templates.filter(t => t.templateType === 'single');
        if (singleTemplates.length > 1) {
          const singleIndex = singleTemplates.findIndex(t => t === template);
          return `單數模板${['一', '二', '三', '四', '五'][singleIndex] || (singleIndex + 1)}`;
        }
        return '單數模板';
      }
      return '模板';
    },
    handleTemplateUpdate(index, content) {
      this.$emit('update-template', { index, content });
    },
  },
};
</script>

<style scoped>
.content-card {
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #eef1f6;
  box-shadow: 0 1px 3px rgba(18, 38, 63, 0.06);
}

.card-title {
  font-size: 1.08rem;
  font-weight: 600;
  color: #2f3542;
  padding: 14px 16px 6px;
}

.v-card__text {
  padding: 8px 16px 16px;
  color: #4a4f57;
  line-height: 1.6;
}

.editor-textarea.v-textarea .v-input__control {
  background-color: #fff;
}

.editor-textarea >>> .v-input__slot {
  border-radius: 10px;
  border: 1px solid #e6e9ef;
}

.save-btn {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
  flex-shrink: 0 !important;
  flex-grow: 0 !important;
}

.template-desc {
  font-size: 0.85rem;
  font-weight: normal;
  color: #666;
}
</style>
